import OrderTypeLayout from "@/pages/order-type/components/OrderTypeLayout";

export default function MarketOrders() {
  return <OrderTypeLayout slug="market-orders" />;
}